
  <div *ngIf="descriptionJson">

    <div *ngFor="let part of parts;" class="mt-2 card ps-2">
        <div>name : {{part['name']}} </div>
        <div>valuetype: {{part['valuetype']}} </div>
        <div>source: {{part['source']}} </div>
        <div *ngIf="part['source']=='system'">boldManager: {{part['boldManager']}}</div>
        <div *ngIf="part['source']=='system'">id: {{part['id']}}</div>
        <div *ngIf="part['source']=='expression'||part['source']=='template'||part['source']=='parts'">value: {{part['value']}}</div>
        <div *ngIf="part['params']">
          params
            <div *ngFor="let param of part['params']" class="ms-2">
              <div class="ms-4">
                valuetype: {{param['valuetype']}},
                source: {{param['source']}},
                value: {{param['value']}}
              </div>
            </div>
        </div>
    </div>

    <div class="mt-2" *ngIf="layouts">
      <div class="alert alert-info">Layouts</div>
    <div *ngFor="let layout of layouts;" class="ms-2 mt-2">
    <app-task-description-topology-one
      *ngIf="layout['topology']=='onepart' && isLoaded"
      [layout]="layout">
    </app-task-description-topology-one>

    <app-task-description-topology-multipart
      *ngIf="layout['topology']=='multipart' && isLoaded"
      [layout]="layout">
    </app-task-description-topology-multipart>

    </div>
    </div>
  </div>
